export default __webpack_public_path__ + "static/media/EADV-logo.8577d319.png";